<template>
  <div class="content-display">
    <VueAgile :dots="false"
        :navButtons="false"
        :infinite="false"
        @after-change="changedSlide($event)"
        ref="carousel"
      
    >
      <ContentCard
        v-for="page in item.content"
        :key="page.title"
        :title="page.title"
        :copy="page.copy"
        :image="page.image"
      />
    </VueAgile>
    <div class="pagination">
      <PaginationBar
        v-if="item.content.length > 1"
        :totalPages="item.content.length"
        :currentPage="currentContentPage"
        :alignment="'center'"
        @pageClick="handlePageClick"
      />
    </div>
  </div>
</template>

<script>
import ContentCard from "./ContentCard.vue";
import PaginationBar from "./PaginationBar.vue";
import { VueAgile } from "vue-agile";

export default {
  name: "",
  components: {
    ContentCard,
    PaginationBar,
    VueAgile,
  },
  props:{
    item:Object
  },
  data: () => {
    return {
      currentContentPage: 0,
      pageWidth: 480,
    };
  },
  methods: {
    handlePageClick(i) {
    //   this.currentContentPage = i;
    this.$refs.carousel.goTo(i);
    },
    changedSlide(event){
        this.currentContentPage = event.currentSlide;
    }
  },
};
</script>

<style>
.content-display {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content-scroller {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-y: hidden;
  overflow-x: auto;
  /*-webkit-overflow-scrolling: touch;*/
  overscroll-behavior-x: auto;
  user-select: none;
  scroll-snap-type: x mandatory;
}

.content-scroller::-webkit-scrollbar {
  display: none;
}
.snap-child-start {
  scroll-snap-align: start;
}
.agile__slides {
    align-items: flex-start;
}
</style>
